const MESSAGES: Record<string, string> = {
  no_match: "No participant matches these filters",
  no_participation: "No participant has started this survey yet",
  not_tracked: "The card-by-card path was not recorded for this survey",
};

export function completionUnavailableMessage(reason: string | null | undefined): string {
  return (reason && MESSAGES[reason]) || "Completion data is not available";
}
